export const dashboard = {
  title: 'Vezérlőpult',
  welcome: {
    morning: 'Jó reggelt',
    afternoon: 'Jó napot',
    evening: 'Jó estét',
    user: 'Felhasználó',
    message: 'Üdvözöljük a YouCRM-ben'
  },
  stats: {
    customers: 'Ügyfelek',
    customersDesc: 'Összes regisztrált ügyfél',
    products: 'Termékek',
    productsDesc: 'Katalógusban szereplő termékek',
    categories: 'Kategóriák',
    categoriesDesc: 'Termék kategóriák száma',
    warehouses: 'Raktárak',
    warehousesDesc: 'Aktív raktárak száma',
    inventory: 'Készlettételek',
    inventoryDesc: 'Összes készlet tétel'
  },
  inventoryOverview: 'Készlet áttekintés',
  totalItems: 'Összes tétel',
  lowStock: 'Alacsony készlet',
  outOfStock: 'Nincs készleten',
  totalValue: 'Teljes érték',
  recentCustomers: 'Legutóbbi ügyfelek',
  recentProducts: 'Legutóbbi termékek',
  lowStockProducts: 'Alacsony készletű termékek',
  viewAll: 'Összes megtekintése',
  noCustomers: 'Nincsenek ügyfelek',
  noProducts: 'Nincsenek termékek',
  noLowStock: 'Minden termék készleten van'
}